import { render, staticRenderFns } from "./UserContractCard.vue?vue&type=template&id=15a3e1e6&"
import script from "./UserContractCard.vue?vue&type=script&lang=js&"
export * from "./UserContractCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports